export const ToastColors = {
    success: '#4CBB17',
    failure: 'red'
}